import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  data as dataSelector,
  data2 as data2Selector,
  advWorkflow as advWorkflowSelector,
  currentClientId as currentClientIdSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../../LargePurchaseWorkflowConstants';

export const purchaseYearOptionsSelector = createSelector(dataSelector, (data) => {
  if (data('YearsOptions')) {
    return (data('HasRetirementGoal') ? ['At Retirement'] : []).concat(data('YearsOptions').map(year => year.toString()));
  }
  return [];
});

const purchaseAtRetirementSelector = createSelector(dataSelector, data2Selector, (data, data2) => {
  const key = `${BACKEND_KEY}.PurchaseAtRetirement`;

  return typeof data2(key) === 'boolean' || data2(key) === '' ? data2(key) : data(key);
});

export const purchaseYearSelector = createSelector(
  dataSelector,
  data2Selector,
  purchaseAtRetirementSelector,
  (data, data2, purchaseAtRetirement) => {
    if (purchaseAtRetirement) {
      return 'At Retirement';
    }

    const key = `${BACKEND_KEY}.DesiredPurchaseYear`;

    return data2(key) || data2(key) === '' ? data2(key) : data(key);
  },
);

export const largePurchaseYearOrDefaultSelector = createSelector(
  advWorkflowSelector,
  currentClientIdSelector,
  (advWorkflow, clientID) =>
    (get(advWorkflow, `${clientID}.data2.${BACKEND_KEY}.PurchaseAtRetirement`, false)
      ? 'At Retirement'
      : get(advWorkflow, `${clientID}.data2.${BACKEND_KEY}.DesiredPurchaseYear`, null)),
);
